/** periodic comm interval (ms) */
export const INTERVAL_TIME = 10000;

/** Maximum number of timestamps in graph */
export const POINT_MAX = 7200;

/** initial zoom level of vertical graph */
export const INITIAL_ZOOM_LEVEL = 18;

/** graph colors */
export const COLORS = {
  pinkRed: { key: '1', color: 'rgb(210, 50,  90)' },
  brightOrange: { key: '2', color: 'rgb(235, 140, 53)' },
  goldenYellow: { key: '3', color: 'rgb(245, 190, 40)' },
  green1: { key: '4', color: 'rgb(120, 190, 80)' },
  teal1: { key: '5', color: 'rgb(60,  165, 140)' },
  sapphireBlue: { key: '6', color: 'rgb(40,  140, 210)' },
  brown: { key: '7', color: 'rgb(190, 150, 60)' },
  darkCyan: { key: '8', color: 'rgb(30,  140, 160)' },
  brownGrey: { key: '9', color: 'rgb(150, 120, 90)' },
  purple1: { key: '10', color: 'rgb(140, 100, 160)' },
  magenta1: { key: '11', color: 'rgb(160, 40,  140)' },
  midnightBlue: { key: '12', color: 'rgb(90,  90,  170)' },
  grey1: { key: '13', color: 'rgb(120, 120, 120)' },
  gold: { key: '14', color: 'rgb(255, 220, 0)' },
  lightOrange: { key: '15', color: 'rgb(255, 120, 50)' },
  red1: { key: '16', color: 'rgb(255, 60,  60)' },
  limeGreen: { key: '17', color: 'rgb(100, 180, 110)' },
  magenta2: { key: '18', color: 'rgb(200, 60,  160)' },
  greyBeige: { key: '19', color: 'rgb(150, 150, 125)' },
  lightBlue1: { key: '20', color: 'rgb(80,  170, 220)' },
  lavender1: { key: '21', color: 'rgb(140, 120, 180)' },
  deepRed: { key: '22', color: 'rgb(170, 80,  80)' },
  lightCoral1: { key: '23', color: 'rgb(240, 90,  90)' },
  magenta3: { key: '24', color: 'rgb(235, 0,   100)' },
  blue1: { key: '25', color: 'rgb(0,   135, 210)' },
  olive: { key: '26', color: 'rgb(130, 130, 50)' },
  pink1: { key: '27', color: 'rgb(220, 100, 180)' },
  rose: { key: '28', color: 'rgb(190, 120, 140)' },
  grey2: { key: '29', color: 'rgb(160, 160, 160)' },
  violet: { key: '30', color: 'rgb(100, 70,  140)' },
  pink2: { key: '31', color: 'rgb(255, 100, 150)' },
  yellowGreen: { key: '32', color: 'rgb(180, 210, 60)' },
  green2: { key: '33', color: 'rgb(0,   150, 70)' },
  blue2: { key: '34', color: 'rgb(90,  120, 200)' },
  lightCoral2: { key: '35', color: 'rgb(255, 180, 130)' },
  turquoise: { key: '36', color: 'rgb(70,  200, 170)' },
  blue3: { key: '37', color: 'rgb(100, 120, 180)' },
  magenta4: { key: '38', color: 'rgb(190, 60,  150)' },
  teal2: { key: '39', color: 'rgb(60,  120, 120)' },
  orange: { key: '40', color: 'rgb(255, 120, 90)' },
  purple2: { key: '41', color: 'rgb(150, 50,  150)' },
  blue4: { key: '42', color: 'rgb(50,  120, 180)' },
  goldenBrown1: { key: '43', color: 'rgb(180, 140, 90)' },
  mainturk: { key: '44', color: 'rgb(20,  170, 120)' },
  goldenBrown2: { key: '45', color: 'rgb(200, 140, 40)' },
  lavender2: { key: '46', color: 'rgb(180, 170, 220)' },
  red2: { key: '47', color: 'rgb(250, 10,  20)' },
  yellow: { key: '48', color: 'rgb(190, 190, 70)' },
  pink3: { key: '49', color: 'rgb(255, 170, 210)' },
  lightBlue2: { key: '50', color: 'rgb(60,  180, 210)' },
};
